import {MutationTree} from "vuex";
import {PoolsState} from "@/store/settings/pools/types";

export const mutations: MutationTree<PoolsState> = {
  setPools: (state, payload) => {
    state.pools = payload
  },
  setPoolItem: (state, payload) => {
    state.poolItem = payload
  }
}